// extracted by mini-css-extract-plugin
module.exports = {"register_content":"finished_register_content__1XTCX","content":"finished_content__2vt_w","smalltitle":"finished_smalltitle__1Iqr9"};